import axios from 'axios';

const headers = (csrfToken) => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-CSRF-Token': csrfToken,
});

export const fetchAgeRestrictionSettings = (teamId, csrfToken) =>
  axios.get(`/teams/${teamId}/age_restriction_settings`, { headers: headers(csrfToken) })
    .then((res) => res.data);

export const createAgeRestrictionSetting = (teamId, name, csrfToken) =>
  axios.post(
    `/teams/${teamId}/age_restriction_settings`,
    { age_restriction_setting: { name } },
    { headers: headers(csrfToken) }
  ).then((res) => res.data);

export const updateAgeRestrictionSetting = (teamId, id, attrs, csrfToken) =>
  axios.patch(
    `/teams/${teamId}/age_restriction_settings/${id}`,
    { age_restriction_setting: attrs },
    { headers: headers(csrfToken) }
  ).then((res) => res.data);

export const deleteAgeRestrictionSetting = (teamId, id, csrfToken) =>
  axios.delete(
    `/teams/${teamId}/age_restriction_settings/${id}`,
    { headers: headers(csrfToken) }
  );
